import type { AnalyticsClient } from './analytics.service';

declare const ga: (...args: unknown[]) => void;
declare const gtag: (...args: unknown[]) => void;
declare const fbq: (...args: unknown[]) => void;

/** Production loads analytics.js (`ga`). */
export const googleAnalyticsClient: AnalyticsClient = {
  pageView(url) {
    ga('set', 'page', url);
    ga('send', 'pageview');
  },
};

/** Staging loads gtag.js, not analytics.js. */
export const gtagClient: AnalyticsClient = {
  pageView(url) {
    gtag('event', 'page_view', { page_path: url });
  },
};

export const facebookPixelClient: AnalyticsClient = {
  pageView(url) {
    fbq('track', 'PageView', { url });
  },
};

export const consoleLogClient: AnalyticsClient = {
  pageView(url) {
    console.log('pageViewEvent', 'event fired:', url);
  },
};

export function clientsFor(envName: string, production: boolean): AnalyticsClient[] {
  const google = { production: googleAnalyticsClient, staging: gtagClient }[envName] ?? consoleLogClient;
  return [google, production ? facebookPixelClient : consoleLogClient];
}
